<template>
    <div id="wrap" class="skpfull_wrap">
        <!-- container -->
        <div id="container">
            <div class="container_wrap">
                <!-- contents -->
                <div id="contents" v-show="contentsView">
                    <div class="contents_wrap">
                        <!-- contents_head -->
                        <h2 class="pg_title">{{ title }}</h2>
                        <!-- //contents_head -->

                        <!-- result_wrap -->
                        <div class="result_wrap">
                            <div class="youSelected_box">
                                <article class="selectd_info">
                                    <dl>
                                        <dt>{{ $t('FIELD.GLOBAL.MODEL.CODE') }}</dt>
                                        <dd v-if="'' === request.NATION_NM">{{ request.MODEL_CD }}</dd>
                                        <dd v-else>{{ request.MODEL_CD }}({{ request.NATION_NM }})</dd>
                                    </dl>
                                    <dl>
                                        <dt>{{ $t('FIELD.GLOBAL.PRODUCT.CATEGORY') }}</dt>
                                        <dd>{{ request.CATE_MAIN_NM }} / {{ request.CATE_SUB_NM }}</dd>
                                    </dl>
                                </article>
                            </div>

                            <!-- Exploed View -->
                            <div v-if="'EE' === erpGroupCode">
                                <table class="data_table_ty2">
                                    <colgroup>
                                        <col width="250" />
                                        <col width="250" />
                                        <col width="*" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>{{ $t('FIELD.SEARCH.MODELS') }}</th>
                                            <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                            <th>{{ $t('FIELD.SEARCH.PDF') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text_center">
                                        <tr v-for="(item, idx) in result" :key="item.BMODEL_ID + item.VERSION + idx">
                                            <td>{{ item.BMODEL_ID }}</td>
                                            <td>{{ item.VERSION }}</td>
                                            <td>
                                                <a
                                                    v-for="(file, idx) in item.attach.rowData"
                                                    :key="file.ATTCH_FILE_SEQ + idx"
                                                    :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                                    download="true"
                                                    target="_blank"
                                                    class="txt_link"
                                                >
                                                    {{ file.FILE_NM }}
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- //Exploed View -->

                            <!-- Other Contents -->
                            <div v-else>
                                <section
                                    data-type="quick"
                                    v-for="(item, idx) in result"
                                    :key="item.BMODEL_ID + item.VERSION + idx"
                                >
                                    <!-- 활성화시 active 클래스 -->
                                    <div class="result_title">
                                        <em @click="constantSection($event)">
                                            {{ item.KNOWLEDGE_TITLE }}
                                            <span class="item-date">({{ item.MODF_DT }})</span>
                                        </em>
                                    </div>
                                    <div class="result_con">
                                        <!-- tab -->
                                        <div class="view_desc">
                                            <!-- tab_wrap -->
                                            <div
                                                class="tab_wrap"
                                                v-if="
                                                    !(
                                                        'This is CMS contents' === item.KNOWLEDGE_DESC ||
                                                        '' === item.KNOWLEDGE_DESC
                                                    )
                                                "
                                            >
                                                <ul class="tab_menu_02 tab_menus">
                                                    <li class="on">
                                                        <a href="javascript:">{{
                                                            $t('SUBTITLE.GLOBAL.DESCRIPTION')
                                                        }}</a>
                                                    </li>
                                                </ul>
                                                <div class="tab_contents">
                                                    <div class="tab_cont" v-html="stripHtml(item.KNOWLEDGE_DESC)">
                                                        <!-- {{ item.KNOWLEDGE_DESC }} -->                       
                                                      
                                                    </div>
                                                      
                                                      <!-- <div class="attachment_wrap">
                                                            <p>
                                                                <em>
                                                                    <i>
                                                                    System stabilization is in progress.<br>
                                                                    11111111111111111111111111111111111                 
                                                                    </i>
                                                                </em>
                                                            </p>
                                                        </div> -->
                                                      

                                                <!-- 본문 watermark 주석 처리
                                                <div class="watermark" style=" left: 30%; top: 30%;"><p><svg viewboxs="0 0 100 100" class="svgBox">        <defs>            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="0%">                 <stop offset="0%" style="stop-color:red;stop-opacity:1"></stop>                 <stop offset="50%" style="stop-color:#747ae8;stop-opacity:1"></stop>                 <stop offset="100%" style="stop-color:#040840;stop-opacity:1"></stop>            </linearGradient>        </defs>        <text style="font-size:18pt;" text-anchor="middle" class="gradient-text-three" x="60px" y="20px">Copyright© 1995-{{ $moment(new Date()).format("YYYY") }} SAMSUNG. All rights reserved. <br> ({{langId}}) </text>    </svg></p></div>
                                                <div class="watermark" style=" left: 60%; top: 60%;"><p><svg viewboxs="0 0 100 100" class="svgBox">        <defs>            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="0%">                 <stop offset="0%" style="stop-color:red;stop-opacity:1"></stop>                 <stop offset="50%" style="stop-color:#747ae8;stop-opacity:1"></stop>                 <stop offset="100%" style="stop-color:#040840;stop-opacity:1"></stop>            </linearGradient>        </defs>        <text style="font-size:18pt;" text-anchor="middle" class="gradient-text-three" x="60px" y="20px">Copyright© 1995-{{ $moment(new Date()).format("YYYY") }} SAMSUNG. All rights reserved. <br> ({{langId}}) </text>    </svg></p></div>
                                                -->

                                                <div style="text-align:right; color: gray;">
                                                     <!--
                                                     Distribution, transmission, or infringement of any content or data from this 
                                                    <br> Copyright© 1995-{{ $moment(item.MODF_DT).format("YYYY") }} SAMSUNG. All rights reserved.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    document without Samsung’s written authorization is strictly prohibited &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                     -->
                                                      <table class="grid_table">
                                                                <colgroup>
                                                                    <col width="50%" />
                                                                    <col width="50%" />
                                                                </colgroup>
                                                                <tbody class="text_center">
                                                                    <tr>
                                                                        <td style="text-align:left; color: gray;">Copyright© 1995-{{ $moment(item.MODF_DT).format("YYYY") }} SAMSUNG. All rights reserved.</td>
                                                                        <td style="text-align:right; color: gray;"> Distribution, transmission, or infringement of any content or data from this<br>   document without Samsung’s written authorization is strictly prohibited &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                    </div>


                                                
                                                <!-- <dl style="stop-color:#040840;stop-opacity:1">
                                                    <dt style="stop-color:#040840;stop-opacity:1">Distribution, transmission, or infringement of any content or data from this <br> document without Samsung’s written authorization is strictly prohibited</dt>                                        
                                                </dl> -->
                                                </div>       
                                                
                                        
                                            </div>
                                            <!-- //tab_wrap -->

                                            <!-- tab_wrap -->
                                            <div class="tab_wrap" v-if="0 < item.part.rowCount">
                                                <ul class="tab_menu_02 tab_menus">
                                                    <li class="on">
                                                        <a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a>
                                                    </li>
                                                </ul>
                                                <div class="tab_contents">
                                                    <div class="tab_cont">
                                                        <!-- Grid -->
                                                        <div class="grid_wrap">
                                                            <table class="grid_table">
                                                                <colgroup>
                                                                    <col width="50%" />
                                                                    <col width="50%" />
                                                                </colgroup>
                                                                <thead>
                                                                    <tr class="text_center">
                                                                        <th>{{ $t('FIELD.GLOBAL.PARTS.CODE') }}</th>
                                                                        <th>{{ $t('FIELD.GLOBAL.PARTS.TYPE') }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="text_center">
                                                                    <tr
                                                                        v-for="(part, idx) in item.part.rowData"
                                                                        :key="part.PARTS_SEQ + idx"
                                                                    >
                                                                        <td>{{ part.PARTS_CODE }}</td>
                                                                        <td>{{ part.PARTS_TYPE }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <!-- //Grid -->
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- //tab_wrap -->

                                            <!-- Attachment -->
                                            <div class="attachment_wrap">
                                                <ul>
                                                    <li
                                                        v-for="(file, idx) in item.attach.rowData"
                                                        :key="file.ATTCH_FILE_SEQ + idx"
                                                    >
                                                        <a
                                                            :href="
                                                                getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)
                                                            "
                                                            download="true"
                                                            target="_blank"
                                                        >
                                                            <span class="ico_attach"></span>
                                                            {{ file.FILE_NM }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <!-- //Attachment -->
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <!-- //Other Contents -->
                        </div>
                    </div>
                </div>
                <!-- contents -->
            </div>
        </div>
        <!-- //container -->
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { SDLUtil, StringUtil } from '@/utils';
import qs from 'query-string';
import axios from 'axios';
import constants from '@/constants';
import store from '@/vuex/store';
import { i18n, loadLanguageAsync } from '@/i18n';
import RequestPassPopup from '~vb/eur/user/RequestPassPopup';

export default {
    name: 'RequestContents',
    props: {
        sk: { required: true },
    },
    data() {
        return {
            contentsView: false,
            erpRequestNo: '',
            erpGroupCode: '',
            langId: '',
            langNo: '',
            langCd: '',
            keyWord: '',
            countryCd: '',
            curExpireDt: '',
            frsExpireDt: '',
            falExpireDt: '',
            encExpireDt: '',
            title: '',
            request: {},
            result: [],
        };
    },
    methods: {
        initLoad() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(`${SDLUtil.API_URL}/noauth/eur/getRequestContentsDetail.skp`, qs.stringify({ sk: this.sk }), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                })
                .then(res => {
                    SDLUtil.showLoadingBar(false);
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                    this.$router.push({ path: '/no_auth' });
                });
        },
        requestPassPopup() {
            SDLUtil.show(
                RequestPassPopup,
                {
                    keyWord: this.keyWord,
                    rtnFunc: arg1 => {
                        this.contentsView = true;
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        constantSection(e) {
            if (
                $(e.target)
                    .closest('section')
                    .hasClass('active') == true
            ) {
                $(e.target)
                    .closest('section')
                    .removeClass('active');
            } else {
                $(e.target)
                    .closest('section')
                    .addClass('active');
            }
        },
        goLoginPage() {
            this.$nextTick(() => {
                SDLUtil.alert({
                    title: 'MESSAGE.EUR.CONT.AUTH',
                    msg: 'MESSAGE.EUR.CONT.AGAIN',
                    onOkEvt: () => {
                        this.$router.push({
                            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`,
                            query: { countryCd: this.countryCd, langCd: this.langCd },
                        });
                    },
                });
            });
        },
        sessionCheck() {
            let date = new Date();
            let curDate =
                date.getUTCFullYear() +
                this.padStart(date.getUTCMonth() + 1) +
                this.padStart(date.getUTCDate()) +
                this.padStart(date.getUTCHours()) +
                this.padStart(date.getUTCMinutes()) +
                this.padStart(date.getUTCSeconds());

            if (StringUtil.isNull(this.langNo) && parseInt(curDate) > parseInt(this.curExpireDt)) {
                // 로컬현재시간 > 서버현재시간+12
                this.goLoginPage();
            } else if (StringUtil.isNull(this.langNo) && parseInt(curDate) < parseInt(this.frsExpireDt)) {
                // 로컬현재시간 < 서버현재시간-12
                this.goLoginPage();
            } else if (StringUtil.isNull(this.langNo) && parseInt(curDate) > parseInt(this.falExpireDt)) {
                // 로컬현재시간 > 이메일유효시간
                this.goLoginPage();
            }
        },
        padStart(v) {
            let val = '' + v;
            if (1 === StringUtil.textLength(val)) {
                val = '0' + v;
            }
            return val;
        },
        passwords(str) {
            let reg = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
            let val = str;
            if (reg.test(str)) {
                val = str.replace(reg, '');
            }
            return val.slice(-5);
        },
        getDownloadUrl(seq, token) {
            let cmnApiBase = `${SDLUtil.API_URL}/noauth/common/attachEurMailDownload.skp`;
            return cmnApiBase + '?attachFileSeq=' + seq + '&token=' + this.encExpireDt;
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
    },
    created() {
        if (StringUtil.isNull(this.sk)) {
            this.goLoginPage();
        } else {
            this.initLoad().then(res => {
                if (0 === res.contentsResult.rowCount) this.goLoginPage();
                this.erpRequestNo = res.search.erpRequestNo;
                this.erpGroupCode = res.search.erpGroupCode;
                this.langId = res.search.langId;
                this.langNo = res.search.langNo;
                this.langCd = res.search.langCd;
                this.request = res.contentsRequest;
                this.result = res.contentsResult.rowData;
                this.title = res.contentsResult.rowData[0].LABEL_OVER_INFO;

                loadLanguageAsync(this.langCd);
                if (StringUtil.isNull(this.langNo)) {
                    this.keyWord = '';
                    res.admin.compNo.forEach(element => {
                        this.keyWord += element;
                    });
                    this.curExpireDt = res.contentsRequest.CUR_EXPIRE_DT;
                    this.frsExpireDt = res.contentsRequest.FRS_EXPIRE_DT;
                    this.falExpireDt = res.contentsRequest.FAL_EXPIRE_DT;
                    this.encExpireDt = res.contentsRequest.ENC_EXPIRE_DT;
                    this.countryCd = res.contentsRequest.COUNTRY_CD;
                    this.sessionCheck();
                    this.requestPassPopup();
                } else if (StringUtil.isNull(this.langId)) {
                    this.contentsView = true;
                } else {
                    this.goLoginPage();
                }
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            $('body').addClass('admin_wrap');
        });
    },
};
</script>

<style scoped>
html /deep/ {
    @import url('/static/css/hhp_admin.css');
}
</style>
<style>
	.watermark{
		webkitTransform:rotate(-20deg);
		MozTransform:rotate(-20deg);
		msTransform:rotate(-20deg);
		OTransform:rotate(-20deg);
		transform: rotate(-20deg);
		position: absolute;
		overflow: visible;
		z-index: 99999;
		pointer-events: none;
		opacity: 0.4;
		font-size: 12px;
		color: rgb(64, 40, 40);
		text-align: center;
		width: 120px;
		height: 50px;
		display: block;
	}
	
    .ani-backup{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1040;
        background-color: #000;
        opacity: .15;
    }
    
    .ani-box svg {
        -webkit-animation:spin 2s linear infinite;
        -moz-animation:spin 2s linear infinite;
        animation:spin 2s linear infinite;
        width:500px;
        height:500px;
    }

    .ani-box-icon{
        position: fixed;
        top: 300px;
        text-align: center;
        width:100%;
    }

    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(-360deg); } }
    @-moz-keyframes spin { 100% { -moz-transform: rotate(-360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(-360deg); transform:rotate(-360deg); } }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/RequestContents.vue